function EventsCtrl($scope, $controller, $location, $rootScope, $sce, $filter, $timeout, $state){

}
